import React from 'react';
import { SignIn as SignInComponent } from 'components/auth/sign-in';
import PageAnimation from 'components/shared/page-animation.';

const SignIn: React.FC = () => {
  return <PageAnimation><SignInComponent /></PageAnimation>;
};

export default SignIn;
